// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--S32Pq","panorama":"a10a3f92e9--panorama--JD7oh","wrapper":"a10a3f92e9--wrapper--o5N72"};